import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_ALL_PLANS_DATA } from 'store/actions';
import { FetchAllPlans } from 'api/subscription';
import Cookies from 'js-cookie';
import { getStartupID } from 'utilities/index';

const DetailsHandler = () => {
    const dispatch = useDispatch();
    const startup_id = getStartupID()
    const { data: allPlans, isLoading: isLoadingPlans } = FetchAllPlans({ startup_id });

    // Effect to set permissions template and user access info
    useEffect(() => {
        if (!isLoadingPlans && allPlans) {
            dispatch({ type: SET_ALL_PLANS_DATA, all_plans: allPlans, loading_plans: false });
        }
        else {
            dispatch({ type: SET_ALL_PLANS_DATA, all_plans: null, loading_plans: true });
        }
    }, [allPlans, isLoadingPlans]);

    return null; // Render nothing; this component just handles logic
};

export default DetailsHandler;
